/* ZANKIRA Solana wallet connect — ported from the Lovable site (client-side only).
   Connect Phantom or paste an address, check on-chain $zankira balance,
   unlock the holder discounts at checkout ($STICK >$1 -> $20 off; $zankira -> 15% off). */
(function () {
  'use strict';
  var STORAGE_KEY = 'zankira-wallet';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function cfg() { return (window.ZANKIRA && window.ZANKIRA.wallet) || {}; }

  function isValidSolanaAddress(address) {
    return /^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(String(address || '').trim());
  }

  function getWeb3() {
    return new Promise(function (resolve) {
      if (window.solanaWeb3) return resolve(window.solanaWeb3);
      var iv = setInterval(function () {
        if (window.solanaWeb3) { clearInterval(iv); resolve(window.solanaWeb3); }
      }, 200);
      setTimeout(function () { clearInterval(iv); resolve(window.solanaWeb3 || null); }, 8000);
    });
  }

  function getBalance(ownerAddress, mint) {
    mint = mint || cfg().mint;
    if (!mint || !ownerAddress) return Promise.resolve(0);
    return getWeb3().then(function (w3) {
      if (!w3) return 0;
      try {
        var connection = new w3.Connection(cfg().rpc || 'https://api.mainnet-beta.solana.com', 'confirmed');
        return connection.getParsedTokenAccountsByOwner(new w3.PublicKey(ownerAddress), {
          mint: new w3.PublicKey(mint)
        }).then(function (res) {
          return res.value.reduce(function (sum, acc) {
            var amt = acc.account.data.parsed && acc.account.data.parsed.info.tokenAmount.uiAmount;
            return sum + (typeof amt === 'number' ? amt : 0);
          }, 0);
        });
      } catch (e) {
        console.error('Failed to fetch token balance:', e);
        return 0;
      }
    }).catch(function () { return 0; });
  }

  function getStickUsdValue(ownerAddress) {
    var stickMint = cfg().stickMint;
    if (!stickMint || !ownerAddress) return Promise.resolve(0);
    return getBalance(ownerAddress, stickMint).then(function (balance) {
      if (!balance) return 0;
      return fetch('https://lite-api.jup.ag/price/v3?ids=' + encodeURIComponent(stickMint))
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var entry = (j && j.data && j.data[stickMint]) || (j && j[stickMint]) || null;
          var price = 0;
          if (entry) {
            price = typeof entry.usdPrice === 'number' ? entry.usdPrice : parseFloat(entry.usdPrice || entry.price);
          }
          return isFinite(price) && price > 0 ? balance * price : 0;
        })
        .catch(function () { return 0; });
    });
  }

  function setHolderUI(root, state) {
    // state: 'checking' | 'stick' | 'holder' | 'notholder'
    var checking = $('[data-zk-wallet-checking]', root);
    var stick = $('[data-zk-wallet-stickholder]', root);
    var holder = $('[data-zk-wallet-holder]', root);
    var notholder = $('[data-zk-wallet-notholder]', root);
    if (checking) checking.hidden = state !== 'checking';
    if (stick) stick.hidden = state !== 'stick';
    if (holder) holder.hidden = state !== 'holder';
    if (notholder) notholder.hidden = state !== 'notholder';
    window.ZANKIRA.isHolder = state === 'stick' || state === 'holder';
    window.ZANKIRA.activeDiscountCode = state === 'stick'
      ? (cfg().stickDiscountCode || 'STICKHOLDER20')
      : state === 'holder' ? (cfg().discountCode || null) : null;
    var note = $('[data-zk-holder-note]');
    if (note) note.hidden = state !== 'holder';
    var snote = $('[data-zk-stick-note]');
    if (snote) snote.hidden = state !== 'stick';
  }

  function showConnected(root, address) {
    var connectView = $('[data-zk-wallet-connect-view]', root);
    var connectedView = $('[data-zk-wallet-connected-view]', root);
    if (connectView) connectView.hidden = true;
    if (connectedView) connectedView.hidden = false;
    var short = $('[data-zk-wallet-short]', root);
    if (short) short.textContent = address.slice(0, 4) + '…' + address.slice(-4);
  }

  function showConnect(root) {
    var connectView = $('[data-zk-wallet-connect-view]', root);
    var connectedView = $('[data-zk-wallet-connected-view]', root);
    if (connectView) connectView.hidden = false;
    if (connectedView) connectedView.hidden = true;
    var manual = $('[data-zk-wallet-manual]', root);
    var btnView = $('[data-zk-wallet-button-view]', root);
    if (manual) manual.hidden = true;
    if (btnView) btnView.hidden = false;
    setHolderUI(root, 'notholder');
    var stick = $('[data-zk-wallet-stickholder]', root);
    var holder = $('[data-zk-wallet-holder]', root);
    var notholder = $('[data-zk-wallet-notholder]', root);
    if (stick) stick.hidden = true;
    if (holder) holder.hidden = true;
    if (notholder) notholder.hidden = true;
  }

  function verify(root, address, silent) {
    try { localStorage.setItem(STORAGE_KEY, address); } catch (e) {}
    showConnected(root, address);
    if (!silent) setHolderUI(root, 'checking');
    getStickUsdValue(address).then(function (usd) {
      if (usd > (cfg().stickMinUsd || 1)) {
        setHolderUI(root, 'stick');
        return;
      }
      getBalance(address).then(function (balance) {
        setHolderUI(root, balance > 0 ? 'holder' : 'notholder');
      });
    });
  }

  function initOne(root) {
    var connectBtn = $('[data-zk-wallet-connect]', root);
    var manualWrap = $('[data-zk-wallet-manual]', root);
    var btnView = $('[data-zk-wallet-button-view]', root);
    var input = $('[data-zk-wallet-input]', root);
    var verifyBtn = $('[data-zk-wallet-verify]', root);
    var errorEl = $('[data-zk-wallet-error]', root);
    var disconnectBtn = $('[data-zk-wallet-disconnect]', root);

    function t(key, fallback) {
      return (window.ZANKIRA.t ? window.ZANKIRA.t(key, fallback) : fallback);
    }

    if (connectBtn) connectBtn.addEventListener('click', function () {
      if (errorEl) errorEl.hidden = true;
      if (window.solana && window.solana.isPhantom) {
        window.solana.connect().then(function (res) {
          verify(root, res.publicKey.toString(), false);
        }).catch(function (e) {
          console.error('Phantom connect failed:', e);
          if (manualWrap) manualWrap.hidden = false;
          if (btnView) btnView.hidden = true;
        });
      } else {
        if (manualWrap) manualWrap.hidden = false;
        if (btnView) btnView.hidden = true;
      }
    });

    function doManual() {
      var addr = (input.value || '').trim();
      if (!isValidSolanaAddress(addr)) {
        if (errorEl) {
          errorEl.textContent = t('cart.invalidAddress', 'Please enter a valid Solana address');
          errorEl.hidden = false;
        }
        return;
      }
      if (errorEl) errorEl.hidden = true;
      if (manualWrap) manualWrap.hidden = true;
      verify(root, addr, false);
    }
    if (verifyBtn) verifyBtn.addEventListener('click', doManual);
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') doManual(); });

    if (disconnectBtn) disconnectBtn.addEventListener('click', function () {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      if (window.solana && window.solana.disconnect) {
        try { window.solana.disconnect(); } catch (e) {}
      }
      if (input) input.value = '';
      showConnect(root);
    });

    // restore saved wallet silently
    var saved = null;
    try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (saved && isValidSolanaAddress(saved)) {
      verify(root, saved, true);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-zk-wallet]'), initOne);
  });
})();
